<template>
    <h2 class="text-lg leading-6 font-semibold text-gray-900 dark:text-white">
        <slot/>
    </h2>
</template>

<script>
export default {
    name: 'element-title',
};
</script>
